'use strict'

const Sharer = {
    elt: null,
    button: null,
    ctn: null,
    headerHeight: 0,
    anchorsHeight: 0,
    initialTop: 0,
    isFixed: false,
    isMobile: true,

    init: function () {
        Sharer.elt = document.querySelector('.c-sharer');
        Sharer.isMobile = window.innerWidth <= 1024;
        window.addEventListener('resize', () => Sharer.isMobile = window.innerWidth <= 1024);
        if (Sharer.elt) {
            Sharer.button = Sharer.elt.querySelector('.c-sharer__cta');
            Sharer.ctn = Sharer.elt.querySelector(".c-sharer__extended");

            Sharer.updateHeights();
            //position initiale
            Sharer.initialTop = Sharer.elt.getBoundingClientRect().top + window.scrollY;
            
            //valeurs par defaut
            Sharer.elt.style.position = "absolute";
            Sharer.elt.style.top = Sharer.isMobile ? "20px" : "60px"; 

            window.addEventListener("scroll", Sharer.handleScroll);

            if (Sharer.button && Sharer.ctn) {
                Sharer.event();
            }
            Sharer.handleScroll();
        }
    },

    updateHeights: function () {
        const header = document.querySelector('.header');
        const anchors = document.querySelector('.c-anchors');

        Sharer.headerHeight = header ? header.offsetHeight : 0;
        Sharer.anchorsHeight = anchors ? anchors.offsetHeight : 0;
    },

    handleScroll: function () {
        const scrollY = window.scrollY;
        const threshold = Sharer.initialTop - Sharer.headerHeight - Sharer.anchorsHeight;
        const footer = document.querySelector('.footer');
        const mainHeight = document.querySelector('.main') ? document.querySelector('.main').offsetHeight : 0;
        const sharerCtn = document.querySelector('.c-sharer__ctn');
        const headerHeroHeight = document.querySelector('.headerHero ') ? document.querySelector('.headerHero ').offsetHeight : 0;
    
        if (!footer) return;
    
        const footerTop = footer.getBoundingClientRect().top + scrollY;
        const sharerHeight = Sharer.elt.offsetHeight;
        const stopPosition = footerTop - sharerHeight - (Sharer.isMobile ? 32 : 128)  - Sharer.headerHeight - Sharer.anchorsHeight;
        
        const sharerCtnTop = sharerCtn.offsetHeight;
        const relativeTop = mainHeight - sharerCtnTop - headerHeroHeight;

    
        if (scrollY >= threshold && scrollY - stopPosition <= 0) {
            Sharer.elt.style.position = "fixed";
            Sharer.elt.style.top = `${Sharer.headerHeight + Sharer.anchorsHeight + (Sharer.isMobile ? 20 : 60)}px`;
            Sharer.isFixed = true;
        } 
        else if (scrollY - stopPosition > 0) {
            Sharer.elt.style.position = "absolute";
            Sharer.elt.style.top = `${relativeTop}px`;
            Sharer.isFixed = false;
        } 
        else {
            Sharer.elt.style.position = "absolute";
            Sharer.elt.style.top = Sharer.isMobile ? "20px" : "60px";
            Sharer.isFixed = false;
        }
    },
    event: function () {
        Sharer.button.addEventListener("click", function (e) {
            e.preventDefault();
            const isExpanded = Sharer.button.getAttribute("aria-expanded") === "true";

            Sharer.ctn.classList.toggle("show--");
            Sharer.button.classList.toggle("active--");
            //Accessibilité
            Sharer.button.setAttribute("aria-expanded", isExpanded ? "false" : "true");
            Sharer.ctn.setAttribute("aria-hidden", isExpanded ? "true" : "false");
        });

        // Clic en dehors pour fermer le menu
        document.addEventListener("click", function (event) {
            if (!Sharer.ctn.contains(event.target) && !Sharer.button.contains(event.target)) {
                Sharer.ctn.classList.remove("show--");
                Sharer.button.classList.remove("active--");
                Sharer.button.setAttribute("aria-expanded", "false");
                Sharer.ctn.setAttribute("aria-hidden", "true");
            }
        });

        const copylink = Sharer.elt.querySelector('.copylink');
        if (copylink) {
            copylink.addEventListener("click", function (e) {
                e.preventDefault();
                navigator.clipboard.writeText(window.location.href)
                    .then(() => {
                        Sharer.elt.querySelector('.c-sharer__info').classList.add('show--');
                        document.getElementById('copy-feedback').innerHTML = Sharer.elt.querySelector('.c-sharer__info').innerHTML;
                        setTimeout(() => {
                            Sharer.elt.querySelector('.c-sharer__info').classList.remove('show--');
                            document.getElementById('copy-feedback').innerHTML = "";
                        }, 1000);
                    })
                    .catch(err => console.error("Erreur de copie :", err));
            });
        }
    }
};

export default Sharer;
